/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataSource } from '../models/DataSource';
import type { DataSourceCreate } from '../models/DataSourceCreate';
import type { DataSourceDetails } from '../models/DataSourceDetails';
import type { DataSourceUpdate } from '../models/DataSourceUpdate';
import type { PaginationInfo } from '../models/PaginationInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DataSourcesService {
    /**
     * List data sources
     * Get paginated list of user's data sources
     * @returns any Data sources retrieved successfully
     * @throws ApiError
     */
    public static getDatasources({
        page = 1,
        limit = 20,
    }: {
        /**
         * Page number for pagination
         */
        page?: number,
        /**
         * Number of items per page
         */
        limit?: number,
    }): CancelablePromise<{
        data?: Array<DataSource>;
        pagination?: PaginationInfo;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/datasources',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized - Authentication required`,
            },
        });
    }
    /**
     * Create data source
     * Create a new database connection
     * @returns DataSource Data source created successfully
     * @throws ApiError
     */
    public static createDatasources({
        requestBody,
    }: {
        requestBody: DataSourceCreate,
    }): CancelablePromise<DataSource> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/datasources',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized - Authentication required`,
                404: `Not found - Agent does not exist`,
            },
        });
    }
    /**
     * Get data source details
     * Retrieve detailed information about a specific data source
     * @returns DataSourceDetails Data source details retrieved successfully
     * @throws ApiError
     */
    public static getDatasources1({
        datasourceId,
    }: {
        /**
         * Data source identifier
         */
        datasourceId: string,
    }): CancelablePromise<DataSourceDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/datasources/{datasource_id}',
            path: {
                'datasource_id': datasourceId,
            },
            errors: {
                401: `Unauthorized - Authentication required`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Update data source
     * Update data source configuration
     * @returns DataSource Data source updated successfully
     * @throws ApiError
     */
    public static updateDatasources({
        datasourceId,
        requestBody,
    }: {
        /**
         * Data source identifier
         */
        datasourceId: string,
        requestBody: DataSourceUpdate,
    }): CancelablePromise<DataSource> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/datasources/{datasource_id}',
            path: {
                'datasource_id': datasourceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized - Authentication required`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Delete data source
     * Remove a data source connection
     * @returns void
     * @throws ApiError
     */
    public static deleteDatasources({
        datasourceId,
        testCleanup = false,
    }: {
        /**
         * Data source identifier
         */
        datasourceId: string,
        /**
         * Flag for test cleanup (hard delete)
         */
        testCleanup?: boolean,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/datasources/{datasource_id}',
            path: {
                'datasource_id': datasourceId,
            },
            query: {
                'test_cleanup': testCleanup,
            },
            errors: {
                401: `Unauthorized - Authentication required`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Update datasource order
     * Update the display order of a specific datasource. This will adjust the order of other datasources to maintain contiguous ordering.
     * @returns DataSource Datasource order updated successfully
     * @throws ApiError
     */
    public static updateDatasourceOrder({
        datasourceId,
        requestBody,
    }: {
        /**
         * Data source identifier
         */
        datasourceId: string,
        requestBody: {
            /**
             * The new order position for the datasource (0-based)
             */
            newOrder: number;
        },
    }): CancelablePromise<DataSource> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/datasources/{datasource_id}/order',
            path: {
                'datasource_id': datasourceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid order value`,
                401: `Unauthorized access`,
                404: `Data source not found`,
            },
        });
    }
    /**
     * Bulk reorder datasources
     * Reorder multiple datasources at once by providing an ordered list of datasource IDs. The datasources will be assigned order values starting from 0.
     * @returns any Datasources reordered successfully
     * @throws ApiError
     */
    public static bulkReorderDatasources({
        requestBody,
    }: {
        requestBody: {
            /**
             * Array of datasource IDs in the desired order
             */
            orderedIds: Array<string>;
        },
    }): CancelablePromise<{
        /**
         * Array of datasources in the new order
         */
        data?: Array<DataSource>;
        pagination?: PaginationInfo;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/datasources/order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid datasource IDs`,
                401: `Unauthorized access`,
                404: `One or more datasources not found`,
            },
        });
    }
}
